import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import AnimationSpinner from "../../AnimationSpinner";
import LoginImage from "../../assets/images/loginPage/Flipbook.jpg";
import darkLogo from "../../assets/images/dark-logo.png";
import { handleInvalidToken } from "../../AuthUtils";
import axios from "axios";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";
import { toast } from "react-toastify";

const ForgotPassReset = ({ base_url }) => {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { varificationCode } = useParams();
    const navigate = useNavigate();
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleShowNewPassword = () => {
        setShowNewPassword(!showNewPassword);
    };
    const handleShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };
    useEffect(() => {
        if (!varificationCode) {
            handleInvalidToken(navigate);
        }
    }, [varificationCode]);

    // sweetalert function--------------------------------------------------------
    function Sweetalert(field) {
        toast.error(field + " is required!");
        // Swal.fire({
        //     icon: "error",
        //     title: "Validation Error",
        //     text: field + " is required!",
        // });
    }
    // handle Submit reqst for reset password-----------------------------------
    const handleSubmit = (event) => {
        event.preventDefault();
        try {
            let isValid = true;
            if (!newPassword && !confirmPassword) {
                Sweetalert("Password & Confirm Password");
                isValid = false;
            } else {
                if (!newPassword) {
                    Sweetalert("Password");
                    isValid = false;
                }
                if (!confirmPassword) {
                    Sweetalert("Confirm password");
                    isValid = false;
                }
                if (newPassword.length < 6 || newPassword.length > 12) {
                    toast.error("Password should be between 6 and 12 characters.");
                    // Swal.fire({
                    //     icon: "error",
                    //     title: "Validation Error",
                    //     text: "Password should be between 6 and 12 characters.",
                    // });
                    isValid = false;
                }
                if (newPassword !== confirmPassword) {
                    toast.error("Password and confirm Password doesn't match");
                    // Swal.fire({
                    //     icon: "error",
                    //     title: "Validation Error",
                    //     text: "Password and confirm Password doesn't match",
                    // });
                    isValid = false;
                }
            }
            if (!isValid) {
                return;
            }
            setLoading(true);
            const formData = new FormData();
            formData.append("action", "resetPasswordAction");
            formData.append("new_password", newPassword);
            formData.append("confirm_password", confirmPassword);
            formData.append("verification_code", varificationCode);

            axios
                .post(`${base_url}api/user/forgot-password`, formData)
                .then((response) => {
                    if (response.data.status === true) {
                        setLoading(false);
                        toast.success("Your password have been changed successfully.");
                        // Swal.fire({
                        //     icon: "success",
                        //     title: "Password Changed",
                        //     text: "Your password have been changed successfully.",
                        // });
                        handleInvalidToken(navigate);
                    } else {
                        setLoading(false);
                        toast.error(response.data.message);
                        // Swal.fire({
                        //     icon: "error",
                        //     title: "Error",
                        //     text: response.data.message,
                        // });
                    }
                });
        } catch (error) {
            setLoading(false);
            toast.error( error.response?.data?.message ||
                error.message ||
                "Something went wrong. Please try again.");
            // Swal.fire({
            //     icon: "error",
            //     title: "Error",
            //     text:
            //         error.response?.data?.message ||
            //         error.message ||
            //         "Something went wrong. Please try again.",
            // });
        }
    };

    return (
        <>
            <div className="min-vh-100 d-flex login-gradient align-items-center justify-content-center p-4"  style={{ background: "linear-gradient(233deg, rgba(242, 234, 234, 0.91) 19%, rgba(247, 247, 247, 0.94) 85%)" }}>
                <div className="main-login-container rounded-3 overflow-hidden position-relative shadow" >
                    <div className="row h-100 g-0 login-content">
                        {/* left side -image */}
                        <div className="col-lg-6 d-none d-lg-block position-relative">
                            <div className="login-img-container">
                                <img
                                    src={LoginImage}
                                    alt="Team collaboration"
                                    layout="fill"
                                    className="rounded-end-3"
                                />
                            </div>
                        </div>

                        {/* right side -form */}
                        <div className="left-login-container col-lg-6 col-md-10 mx-auto p-4 p-lg-5">
                            <div className="mb-4 mb-lg-4 text-center">
                                <div className="loginPage-logo-container mx-auto">
                                    <img src={darkLogo} alt="Book Flow" />
                                </div>
                            </div>

                            <div className="mb-4 text-center">
                                <h1 className="h4">Reset your password</h1>
                                <p className="text-muted">Please enter your new password.</p>
                            </div>

                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="newPassword" className="form-label small text-muted fw-semibold">
                                        New Password
                                    </label>
                                    <div className="position-relative">
                                        <input
                                            type={!showNewPassword ? "password" : "text"}
                                            id="newPassword"
                                            name="newPassword"
                                            placeholder="Enter your new password"
                                            className="form-control login"
                                            value={newPassword}
                                            onChange={({ target: { value } }) =>
                                                setNewPassword(value)
                                            }
                                        />
                                        <div
                                            className="login-input-icon position-absolute"
                                            onClick={handleShowNewPassword}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {showNewPassword ? (
                                                <FaRegEyeSlash />
                                            ) : (
                                                <FaRegEye />
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <label htmlFor="confirmPassword" className="form-label small text-muted fw-semibold">
                                        Confirm Password
                                    </label>
                                    <div className="position-relative">
                                        <input
                                            type={!showConfirmPassword ? "password" : "text"}
                                            id="confirmPassword"
                                            name="confirmPassword"
                                            placeholder="Confirm your new password"
                                            className="form-control login"
                                            value={confirmPassword}
                                            onChange={({ target: { value } }) =>
                                                setConfirmPassword(value)
                                            }
                                        />
                                        <div
                                            className="login-input-icon position-absolute"
                                            onClick={handleShowConfirmPassword}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {showConfirmPassword ? (
                                                <FaRegEyeSlash />
                                            ) : (
                                                <FaRegEye />
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <button type="submit" className="btn w-100 text-white" style={{ backgroundColor: "rgb(111, 9, 81)" }}>
                                    Reset Password
                                </button>
                            </form>

                            <div className="mt-3">
                                <span className="go-back">Go back to </span>
                                <Link to="/login" className="login-link">
                                    Login
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgotPassReset;